import React, { useState } from "react";
// moment
import moment from "moment";
// redux
import { useSelector } from "react-redux";
// alerta
import SchedulingAlert from "../../../components/SchedulingAlert";
// service
import { deleteSchedule } from "../../../services/scheduling";
// componentes
import CardItem from "../../../components/CardItem";

export default function ItemSaved(props) {
  const { data, getListSaved } = props;
  // redux
  const { user, config } = useSelector((state) => state.scheduling);
  const [confirm, setConfirm] = useState(false);
  const [success, setSuccess] = useState(false);

  function formatDate(date) {
    if (!date) return "";

    const newDate = new Intl.DateTimeFormat("pt-BR", {
      timeZone: "America/Sao_Paulo",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(new Date(date));

    return newDate;
  }

  function deleteScheduleFunc() {
    deleteSchedule(data.id)
      .then((res) => {
        if (res.message === "DELETED") {
          setSuccess(true);
          setConfirm(false);
        }
      })
      .catch((error) => console.log("erro", error));

    return;
  }

  return (
    <>
      {confirm && (
        <SchedulingAlert
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          title="Deseja excluir essa atividade da sua agenda?"
          onCancel={() => setConfirm(false)}
          onConfirm={() => deleteScheduleFunc()}
        />
      )}

      {success && (
        <SchedulingAlert
          success
          title="Atividade removida com sucesso!"
          onConfirm={() => {
            setSuccess(false);
            getListSaved(user.idEvent, user.idPart);
          }}
        />
      )}

      <CardItem
        leadingIcon="bx bx-check-circle"
        title={`${data.sala} - ${formatDate(data.dataHoraInicio)}`}
        subtitle={data.atividade}
        action={
          config.allowDeleteAppointment
            ? {
                icon: "bx bx-trash",
                label: `Excluir ${data.atividade} da minha agenda`,
                onClick: () => setConfirm(true),
              }
            : undefined
        }
      />
    </>
  );
}
